const context = require.context('.', true, /\.tsx$/);
export const FILTERS: any = {};

context.keys().forEach((key) => {
  FILTERS[key.slice(2, -4)] = context(key).default;
});

const FILTERS_LIST = [
  FILTERS.FilterOperator,
  FILTERS.FilterTransitionsCount,
  FILTERS.FilterTransitionsTime,
  FILTERS.FilterFlightType,
  FILTERS.FilterLuggageType,
  FILTERS.FilterForwardDeparture,
  FILTERS.FilterBackwardDeparture,
  FILTERS.FilterForwardAirline,
  FILTERS.FilterBackwardAirline,
  FILTERS.FilterDepartureAirport,
  FILTERS.FilterArrivalAirport,
  FILTERS.FilterFlightClass,
];

export default FILTERS_LIST;
